import { render, staticRenderFns } from "./DetailAnnouncementClosed.html?vue&type=template&id=644e46c8&scoped=true&external"
import script from "./DetailAnnouncementClosed.vue?vue&type=script&lang=js"
export * from "./DetailAnnouncementClosed.vue?vue&type=script&lang=js"
import style0 from "./DetailAnnouncementClosed.scss?vue&type=style&index=0&id=644e46c8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644e46c8",
  null
  
)

export default component.exports